import React, { useEffect } from 'react'
import '../styles/Tutor.css'
import { useState } from 'react'

function Tutor(props) {

    var setScreen = props.ScreenImg;
    var showText = props.ShowText;
    var theTheme = props.Theme;

    const [TutorAndroid, setTutorAndroid] = useState('TutorPhoneAndroid gone');
    const [SingDroid, setSingDroid] = useState('SingDroid gone');
    const [ScreenText, setScreenText] = useState('');
    const [zeigeSprechblase, setSprechblase] = useState('SprechblaseWrapper gone');
    const [WorldTheme, setWorldTheme] = useState('Default');
    const [TutorWrapper, setTutorWrapper] = useState('TutorWrapperDefault');
    const [TutorPhoneFrame, setTutorPhoneFrame] = useState('TutorPhoneFrameDefault');
    const [TutorPhoneScreen, setTutorPhoneScreen] = useState('TutorPhoneScreenDefault');
    const [TutorPhoneHomeButton, setTutorPhoneHomeButton] = useState('TutorPhoneHomeButtonDefault');
    const [Rotate1, setRotate1] = useState('Rotate1Default');
    const [Rotate2, setRotate2] = useState('Rotate2Default');

    const TutorialTexte = [
        "Hey! Ich möchte gern ein kleines Lese- und Geschwindigkeitsspiel mit dir spielen. Bist du bereit?", 
        "Also, pass auf, das Spiel geht so:",
        "Ich zeige dir ein Wort. Zum Beispiel das hier:",
        "Als erstes, versuche das Wort zu lesen.",
        "Wenn du es gelesen hast, dann tippe auf die WEITER-Taste!",
        "Prima! Und jetzt zeige ich dir noch ein Wort. Zum Beispiel das hier:",
        "Und jetzt Achtung: Wenn du denkst, dass das jetzt wieder dasselbe, gesuchte Wort ist, dann tippst du auf diese Tasten mit dem Häkchen darauf.",
        "Wenn du aber denkst, dass das jetzt ein anderes und nicht das gesuchte Wort ist, dann tippst du auf diese Taste mit dem Kreuz darauf.",
        "Gut. Und was ist mit diesem Wort?",
        "Denkst du, dass das wieder das gesuchte Wort ist? Oder ist das ein anderes Wort? Tippe auf die passende Taste!",
        "Okay! Und was ist mit diesem Wort? Ist das das gesuchte Wort oder ein anderes? Entscheide dich!",
        "Hm, ziemlich gut.",
        "Jetzt gibt es ein neues gesuchtes Wort.", 
        "Nämlich das hier. Versuch es zu lesen, dann tippe auf die WEITER-Taste!",
        "So und dieses Wort? Ist das jetzt wieder das gesuchte Wort oder ein anderes. Tippe auf die richtige Taste!",
        "Und das Wort hier? Ist das das gesuchte Wort aus der Lupe? Entscheide!",
        "Und das Wort hier?",
        "Und manchmal, da ist das gesuchte Wort auf einem Bild zu sehen. Was siehst du hier?",
        "Wenn du jetzt weißt, was das gesuchte Wort ist, dann tippe auf die WEITER-Taste",
        "Gut. Jetzt muss dann wieder gelesen werden: Ist das hier das gesuchte Wort, das eben auf dem Bild zu sehen war?",
        "Drücke die richtige Taste!",
        "Super! Und das hier? Ist das das gesuchte Wort von dem Bild?",
        "Richtig gut gemacht! Jetzt kommen noch viele weitere Wörter. Versuch immer, so schnell wie möglich zu antworten.",
        "Viel Glück!",
        "Das neue gesuchte Wort ist:",
        "Wunderbar gemacht!",
        "Und jetzt machen wir etwas anderes. Jetzt zeige ich dir einen Satz. Zum Beispiel diesen hier:",
        "Versuch den Satz zu lesen.",
        "Wenn du denkst, dass das, was da steht, stimmt, dann drückst du auf die grüne Taste mit den Häkchen darauf.",
        "Wenn du aber denkst, dass das Quatsch ist...und das, was da steht, nicht stimmt, dann drückst du auf die rote Taste mit dem Kreuz darauf.",
        "Ja, genau so. Und was ist mit diesem Satz?",
        "Stimmt das, was der Satz sagt, dann tippe auf das Häkchen. Oder stimmt es nicht? Dann tippe auf das Kreuz!",
        "Und dieser Satz? Stimmt der oder stimmt der nicht? Entscheide!",
        "Ich denke, du hast es verstanden",
        "Jetzt kommen noch viele weitere Sätze. Also...",
        "Erstens: Versuch die Sätze zu lesen!",
        "Zweitens: Versuch möglichst schnell zu antworten!",
        "Drittens: Viel Glück!!!",
        "Du hast es geschafft und bist fertig!",
        "Vielen Dank, dass du an meinem kleinen Quiz teilgenommen hast!",
        "Dann tschüss und bis bald!"
    ]

    useEffect(()=> {
        if(theTheme == "SecretDucks"){
            setWorldTheme('SecretDucks');  
            setTutorWrapper('TutorWrapperSD');  
            setTutorPhoneFrame('TutorPhoneFrameSD'); 
            setTutorPhoneHomeButton('TutorPhoneHomeButtonSD')   
            setRotate1('Rotate1SD');
            setRotate2('Rotate2SD');     
        }
        if(theTheme == "Default"){
            setWorldTheme('Default');
            setTutorWrapper('TutorWrapperSD');  
            setTutorPhoneFrame('TutorPhoneFrameDefault'); 
            setTutorPhoneHomeButton('TutorPhoneHomeButtonDefault');
            setRotate1('Rotate1Default'); 
            setRotate2('Rotate2Default');    
        }
    })

    useEffect(() => {
        if(setScreen=="Android"){
            if(theTheme=="Default")
            {setTutorPhoneScreen('TutorPhoneScreenDefaultWait')}
            if(theTheme=="SecretDucks")
            {setTutorAndroid('TutorPhoneAndroid'); 
            setSingDroid('SingDroid gone');
            setTutorPhoneScreen('TutorPhoneScreenSD');}}
        if(setScreen=="Neutral"){
            if(theTheme=="SecretDucks")
            {setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidN');}
            if(theTheme=="Default"){setTutorPhoneScreen('TutorPhoneScreenDefaultN')}}
        if(setScreen=="Point"){
            if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidPoint');}
            if(theTheme=="Default"){setTutorPhoneScreen('TutorPhoneScreenDefaultP');}
        }
        if(setScreen=="Think"){if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidThink');}}
        if(setScreen=="Doubt"){if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidThink');}}
        if(setScreen=="StopIt"){if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidThink');}}
        if(setScreen=="Loben")
        {if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidLob');}
        if(theTheme=="Default"){setTutorPhoneScreen('TutorPhoneScreenDefaultLob')};
        }
        if(setScreen=="Love"){if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidLove');}}
        if(setScreen=="Talk")
        {if(theTheme=="SecretDucks")
        {setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidTalk');}
        if(theTheme=="Default"){setTutorPhoneScreen('TutorPhoneScreenDefaultT')}}
        if(setScreen=="Oh"){if(theTheme=="SecretDucks"){setTutorAndroid('TutorPhoneAndroid gone');setSingDroid('SingDroidOh');}}

    })

    useEffect(()=>{
        if(theTheme=="SecretDucks"){
        if(showText == "0"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper gone')}, 1000);
        }
        if(showText == "1"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[0])}, 2000);
        }
        if(showText == "2"){setScreenText(TutorialTexte[1]);}
        if(showText == "3"){setScreenText(TutorialTexte[2]);}
        if(showText == "4"){setScreenText(TutorialTexte[3]);}
        if(showText == "5"){setScreenText(TutorialTexte[4]);}
        if(showText == "5b"){setScreenText(TutorialTexte[5]);}
        if(showText == "6"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[5])}, 2000);
        }
        if(showText == "7"){setScreenText(TutorialTexte[6]);}
        if(showText == "8"){setScreenText(TutorialTexte[7]);}
        if(showText == "8b"){setScreenText(TutorialTexte[8]);}
        if(showText == "9"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[8])}, 2000);
        }
        if(showText == "10"){setScreenText(TutorialTexte[9]);}
        if(showText == "10b"){setScreenText(TutorialTexte[10]);}
        if(showText == "11"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[10])}, 2000);
        }
        if(showText == "11b"){setScreenText(TutorialTexte[11]);}
        if(showText == "12"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[11])}, 2000);
        }
        if(showText == "13"){setScreenText(TutorialTexte[12]);}
        if(showText == "14"){setScreenText(TutorialTexte[13]);}
        if(showText == "14b"){setScreenText(TutorialTexte[14]);}
        if(showText == "15"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[14])}, 2000);
        }
        if(showText == "15b"){setScreenText(TutorialTexte[15]);}
        if(showText == "16"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[15])}, 2000);
        }
        if(showText == "16b"){setScreenText(TutorialTexte[16]);}
        if(showText == "17"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[16])}, 2000);
        }
        if(showText == "17b"){setScreenText(TutorialTexte[17]);}
        if(showText == "18"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[17])}, 2000);
        }
        if(showText == "19"){setScreenText(TutorialTexte[18]);}
        if(showText == "19b"){setScreenText(TutorialTexte[19]);}
        if(showText == "20"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[19])}, 2000);
        }
        if(showText == "21"){setScreenText(TutorialTexte[20]);}
        if(showText == "21b"){setScreenText(TutorialTexte[21]);}
        if(showText == "22"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[21])}, 2000);
        }
        if(showText == "22b"){setScreenText(TutorialTexte[22]);}
        if(showText == "23"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[22])}, 2000);
        }
        if(showText == "24"){setScreenText(TutorialTexte[23]);}
        if(showText == "24b"){setScreenText(TutorialTexte[24]);}
        if(showText == "25"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[24])}, 2000);
        }
        if(showText == "25b"){setScreenText(TutorialTexte[25]);}
        if(showText == "26"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[25])}, 2000);
        }
        if(showText == "27"){setScreenText(TutorialTexte[26]);}
        if(showText == "28"){setScreenText(TutorialTexte[27]);}
        if(showText == "29"){setScreenText(TutorialTexte[28]);}
        if(showText == "30"){setScreenText(TutorialTexte[29]);}
        if(showText == "30b"){setScreenText(TutorialTexte[30]);}
        if(showText == "31"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[30])}, 2000);
        }
        if(showText == "32"){setScreenText(TutorialTexte[31]);}
        if(showText == "32b"){setScreenText(TutorialTexte[32]);}
        if(showText == "33"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[32])}, 2000);
        }
        if(showText == "33b"){setScreenText(TutorialTexte[33]);}
        if(showText == "34"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[33])}, 2000);
        }
        if(showText == "35"){setScreenText(TutorialTexte[34]);}
        if(showText == "36"){setScreenText(TutorialTexte[35]);}
        if(showText == "37"){setScreenText(TutorialTexte[36]);}
        if(showText == "38"){setScreenText(TutorialTexte[37]);}
        if(showText == "38b"){setScreenText(TutorialTexte[38]);}
        if(showText == "39"){
            setTimeout(() => {setSprechblase('SprechblaseWrapper')}, 1000);
            setTimeout(() => {setScreenText(TutorialTexte[38])}, 2000);
        }
        if(showText == "40"){setScreenText(TutorialTexte[39]);}
        if(showText == "41"){setScreenText(TutorialTexte[40]);}
    }
    })

  return (
    <div className={TutorWrapper}>
        <div className={TutorPhoneFrame}>
            <div className={SingDroid}></div>         
        </div>
        <div className={zeigeSprechblase}>
            <div className='SprechblaseBlase'>{ScreenText}</div>
            <div className='SprechblaseNase'></div>
        </div>
    </div>
  )
}

export default Tutor